
  import { Component, Vue } from "vue-property-decorator";

  @Component({})
  export default class HotkeyInfo extends Vue {
    get toolbarItems() {
      const res = [];
      res.push({icon: "tb-new-info", txt: "hotkey_info.toolbar_new"})
      res.push({icon: "tb-save-lat-info", txt: "hotkey_info.toolbar_save_lattice"})
      res.push({icon: "tb-save-info", txt: "hotkey_info.toolbar_save"})
      res.push({icon: "tb-copy-info", txt: "hotkey_info.toolbar_copy"})
      res.push({icon: "tb-undo-info", txt: "hotkey_info.toolbar_undo"})
      res.push({icon: "tb-redo-info", txt: "hotkey_info.toolbar_redo"})
      res.push({icon: "tb-help-info", txt: "hotkey_info.toolbar_help"})
      res.push({icon: "tb-follow-info", txt: "hotkey_info.toolbar_follow"})
      return res;
    }
  }
